import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal as ModalBase } from 'reactstrap';

export const Modal = ({ children, className, isOpen, size, toggle }) => {
  return (
    <ModalBase
      className={classNames(['custom-modal', className])}
      isOpen={isOpen}
      size={size}
      toggle={toggle}
      fade
    >
      {children}
    </ModalBase>
  );
};

Modal.defaultProps = {
  className: '',
  isOpen: false,
  size: 'sm',
  toggle: () => false,
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  // callback for toggling isOpen in the controlling component
  toggle: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
